import { Cloud$Package } from '@otovo/shared/types/cloudApi';

export default function sortPackagesByPanels(
  packages: Array<Cloud$Package>,
): Array<Cloud$Package> {
  return [...packages].sort((a, b) => a.price.num_panels - b.price.num_panels);
}
